import { Dialog, Transition, TransitionChild, DialogPanel, DialogTitle } from '@headlessui/react'
import { forwardRef, useImperativeHandle, useState } from "react";
import { InfinitySpin,Audio ,ThreeDots} from 'react-loader-spinner';

const Loader = forwardRef((props, ref) => {
    let [isOpen, setIsOpen] = useState(false)
    
    function open() {
        setIsOpen(true)
    }

   
    useImperativeHandle(ref, () => ({
        toggleState () {
            setIsOpen(!isOpen)
          }
    }));


    return (
        <>
            <Transition appear show={isOpen}>
                <Dialog as="div" className="relative z-10 focus:outline-none" onClose={open}>
                <div className="fixed inset-0 " aria-hidden="true" />
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 transform-[scale(95%)]"
                        enterTo="opacity-100 transform-[scale(100%)]"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 transform-[scale(100%)]"
                        leaveTo="opacity-0 transform-[scale(95%)]"
                    >
                        <DialogPanel className="w-full max-w-md p-7">
                            <DialogTitle as="h3" className="text-base/7 font-medium text-gray-600">
                                {/* Payment successful */}
                            </DialogTitle>
                            <div className='flex w-full items-center mx-auto'>
                                <div className="spinner mx-auto">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                            <div className='flex items-center justify-center'>
                                    {/*<InfinitySpin color='black'/>*/}
                                    <ThreeDots
                                    height="50"
                                    width="50"
                                    color="#17293F"
                                    ariaLabel="audio-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="wrapper-class"
                                    visible={true}
                                    />
                                    
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                    </div>
                </div>
                </Dialog>
            </Transition>
        </>
    );
})

export default Loader;

{/*bg-[#1C1C1C]   backdrop-blur-2xl*/}